// Single place for the provisional product name. Server copy uses EMAIL_FROM_NAME.
export const BRAND = {
  name: "TrustSubs",
  wordmark: "TRUSTSUBS",
  statusLabel: "Early access",
  company: "ThinkAI",
  tagline: "Subscriptions you can trust.",
};
